var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "a20139081e94778bd60ea7f38c3c40fa.png",
    width: 450,
    height: 584
});